import { FormikProps } from "formik";
import _ from "lodash";

import {
  EPayableBackTransactionStatus,
  ETransactionStatus,
  ETransactionType,
} from "entities/Deal/constants";
import { ITransaction, ITransactionValuesForm } from "entities/Deal/sdk";

export const checkAndUpdateStatusOnTypeChange = ({
  formik,
  status,
}: {
  formik: FormikProps<ITransactionValuesForm>;
  status: typeof EPayableBackTransactionStatus | typeof ETransactionStatus;
}) => {
  if (
    !_.isNil(formik.values.status) &&
    !Object.values(Object.values(status)).includes(formik.values.status)
  ) {
    formik.setFieldValue("status", null);
  }
};

export const getTransactionTypeFromTransactionOrFormValues = ({
  transactionInfo,
}: {
  transactionInfo: ITransaction | ITransactionValuesForm;
}) => {
  if (!_.isNil(transactionInfo.equity_transaction)) {
    return ETransactionType.EQUITY_TRANSACTION;
  }
  if (!_.isNil(transactionInfo.debt_transaction)) {
    return ETransactionType.DEBT_TRANSACTION;
  }
  if (!_.isNil(transactionInfo.tax_credit_allocation_transaction)) {
    return ETransactionType.TAX_CREDIT_ALLOCATION_TRANSACTION;
  }
  if (!_.isNil(transactionInfo.grant_transaction)) {
    return ETransactionType.GRANT_TRANSACTION;
  }
  if (!_.isNil(transactionInfo.other_transaction)) {
    return ETransactionType.OTHER_TRANSACTION;
  }
  return null;
};
